import { render, staticRenderFns } from "./BottomSheetMailboxesSelection.vue?vue&type=template&id=7c409f30&scoped=true&"
import script from "./BottomSheetMailboxesSelection.vue?vue&type=script&lang=js&"
export * from "./BottomSheetMailboxesSelection.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetMailboxesSelection.vue?vue&type=style&index=0&id=7c409f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c409f30",
  null
  
)

export default component.exports